import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';

import {
  AppBar,
  Toolbar,
  Typography,
  Chip,
  Dialog,
  IconButton,
  Hidden,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import MenuOutlined from '@material-ui/icons/MenuOutlined';

import LoginModal from '../../auth/components/LoginModal';
import CommonNavItems from '../components/CommonNavItems';
import CommonMobileNavItems from '../components/CommonMobileNavItems';

import * as authActions from '../../auth/actions';
import classes from '../../css/getCSS';

import { getLogo } from '../../util';


class Navbar extends Component {
  state = {
    loginModalOpen: false,
    mobileMenuOpen: false,
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  handleClickOpen = () => {
    this.setState({
      loginModalOpen: true,
    });
  }

  handleClose = () => {
    this.setState({
      loginModalOpen: false,
    });
  }

  openMobileMenu = () => {
    this.setState({
      mobileMenuOpen: true,
    });
  }

  closeMobileMenu = () => {
    this.setState({
      mobileMenuOpen: false,
    });
  }

  render() {
    const logo = getLogo();

    const mobileDialog = (
      <Dialog
        fullScreen
        open={this.state.mobileMenuOpen}
        onClose={this.closeMobileMenu}
        classes={{
          paper: classes.dialogCard,
        }}
      >
        <AppBar style={{ position: 'relative' }}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>Menu</Typography>
            <IconButton color="inherit" onClick={this.closeMobileMenu} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <CommonMobileNavItems />
      </Dialog>
    );

    const classNames = [classes.mainNavbar];
    if (this.props.homeNavbar) {
      classNames.push(classes.homeNavbar);
    }
    if (this.props.solidNavbar) {
      const index = classNames.indexOf(classes.homeNavbar);
      if (index > -1) {
        classNames.splice(index, 1);
      }
    }

    const content = (
      <div className={classes.navWrapper}>
        <AppBar className={classNames.join(' ')} elevation={0}>
          <Toolbar>

            <Typography variant="title" color="inherit" className={classes.grow}>
              <Link to="/" className={classes.linkDeCSS}>
                <img src={logo} alt="anjal" className={classes.navLogo} />
              </Link>
            </Typography>

            <CommonNavItems />
            <Chip label="LOGIN" className={classes.loginButton} clickable variant="outlined" color="default" onClick={this.handleClickOpen} />
            <Hidden mdUp>
              <IconButton
                className={classes.iconMenuButton}
                onClick={this.openMobileMenu}
              >
                <MenuOutlined />
              </IconButton>
            </Hidden>
          </Toolbar>
        </AppBar>
        <LoginModal
          loginModalOpen={this.state.loginModalOpen}
          handleClose={this.handleClose}
          navigateToLogin={this.navigateToLogin}
        />
        {mobileDialog}
      </div>
    );

    return content;
  }
}

const mapStateToProps = (state) => {
  return {
    site: state.common.site,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));



// WEBPACK FOOTER //
// ./src/common/containers/Navbar.js